import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
/* src/app/page.mypage/view.scss: no such file or directory */`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public isUserLoading = false;
    public userLoadError = false;
    public isProfileSubmitting: boolean = false;

    public get groupNames(): string[] {
        return (this.user?.my_group || '').split(',').map((name: string) => name.trim()).filter(Boolean);
    }

    public qrCodeImage: string | null = null;
    public otpPassword: string = '';
    public otpCode: string = '';
    public currentPassword: string = '';
    public currentOtp: string = '';
    public errorMessages: any = {};
    public isVerified: boolean = false;
    public isPasswordResetPending: boolean = false;
    public isOtpVerified: boolean = false;
    public isOtpResetPending: boolean = false;
    public isSecuritySubmitting: boolean = false;
    public isEmailChangeOpen: boolean = false;
    public emailChangeStep: 'identity' | 'verify' = 'identity';
    public emailChangeMessage: string = '';
    public emailChangeMessageType: 'success' | 'error' = 'error';
    public isEmailChangeSubmitting: boolean = false;
    public emailChangePending: boolean = false;
    public emailChangeLocked: boolean = false;
    public emailChange: any = {
        email: '',
        password: '',
        otp: '',
        onetimepass: ''
    };
    public activeTab: string = 'info';

    public tabs = [
        { key: 'info', label: '기본 정보' },
        { key: 'password', label: '비밀번호 초기화' },
        { key: 'otp', label: 'OTP 초기화' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.loadUserInfo();
        const recovery = await this.securityRequest('get_password_reset_state');
        this.isPasswordResetPending = recovery.code === 200 && recovery.data?.pending === true;
        const otpRecovery = await this.securityRequest('get_otp_reset_state');
        this.isOtpResetPending = otpRecovery.code === 200 && otpRecovery.data?.pending === true;
    }

    private async securityRequest(action: string, params: any = {}) {
        this.isSecuritySubmitting = true;
        this.service.loading.show();
        try {
            return await wiz.call(action, params, { timeout: 135000 });
        } catch (error) {
            return { code: 503, data: (action === 'reset_password' || action === 'reissue_otp')
                ? { message: '초기화 결과를 확인하지 못했습니다. 다시 시도해주세요.', retry: true }
                : '요청을 완료하지 못했습니다. 다시 인증해주세요.' };
        } finally {
            this.isSecuritySubmitting = false;
            this.service.loading.hide();
        }
    }

    private securityError(response: any) {
        return response?.data?.message || response?.data || '요청에 실패했습니다. 다시 인증해주세요.';
    }

    private credentialError(password: string, otp: string): string {
        if (!password) return '현재 비밀번호를 입력해주세요.';
        if (!/^[0-9]{6}$/.test((otp || '').trim())) return 'OTP 인증번호는 숫자 6자리로 입력해주세요.';
        return '';
    }

    public async verifyPassword() {
        if (this.isSecuritySubmitting) return;
        const error = this.credentialError(this.currentPassword, this.currentOtp);
        if (error) return await this.service.alert.warning(error);
        this.isVerified = this.isOtpVerified = false;
        const response = await this.securityRequest('verify_password', {
            password: this.currentPassword + this.currentOtp.trim(), purpose: 'reset_password'
        });
        this.currentPassword = this.currentOtp = '';
        if (response.code === 200) {
            this.isVerified = true;
            await this.service.alert.success("비밀번호 인증 성공");
        } else {
            await this.service.alert.error(this.securityError(response));
        }
    }

    public async confirmPasswordReset() {
        if (this.isSecuritySubmitting || (!this.isVerified && !this.isPasswordResetPending)) return;
        const confirm = await this.service.alert.warning("비밀번호를 초기화하시겠습니까?");
        if (!confirm || this.isSecuritySubmitting || (!this.isVerified && !this.isPasswordResetPending)) return;
        this.isVerified = false;
        const response = await this.securityRequest('reset_password');
        this.isPasswordResetPending = response.code !== 200 && response.data?.retry === true;
        if (response.code === 200) {
            await this.service.alert.success("비밀번호 초기화가 완료되었습니다.\n초기 비밀번호는 이메일로 발송되었습니다.\n메일을 확인하여 비밀번호 재설정을 진행해주세요.");
            window.location.href = '/auth/logout';
        } else {
            await this.service.alert.error(this.securityError(response));
        }
    }

    public async verifyOtpPassword() {
        if (this.isSecuritySubmitting) return;
        const error = this.credentialError(this.otpPassword, this.otpCode);
        if (error) return await this.service.alert.warning(error);
        this.isVerified = this.isOtpVerified = false;
        const response = await this.securityRequest('verify_password', {
            password: this.otpPassword + this.otpCode.trim(), purpose: 'reissue_otp'
        });
        this.otpPassword = this.otpCode = '';
        if (response.code === 200) {
            this.isOtpVerified = true;
            await this.service.alert.success("비밀번호 인증 성공");
        } else {
            await this.service.alert.error(this.securityError(response));
        }
    }

    public async confirmOtpReissue() {
        if (this.isSecuritySubmitting || (!this.isOtpVerified && !this.isOtpResetPending)) return;
        const confirm = await this.service.alert.warning("OTP를 초기화하시겠습니까?");
        if (!confirm || this.isSecuritySubmitting || (!this.isOtpVerified && !this.isOtpResetPending)) return;
        this.isOtpVerified = false;
        const response = await this.securityRequest('reissue_otp');
        this.isOtpResetPending = response.code !== 200 && response.data?.retry === true;
        if (response.code === 200) {
            await this.service.alert.success("OTP 초기화가 완료되었습니다.\n재접속하여 OTP 재발급을 진행해주세요");
            window.location.href = '/auth/logout';
        } else {
            await this.service.alert.error(this.securityError(response));
        }
    }

    public async setTab(tab: string) {
        if (this.isSecuritySubmitting) return;
        this.isVerified = this.isOtpVerified = false;
        this.currentPassword = this.currentOtp = this.otpPassword = this.otpCode = '';
        this.activeTab = tab;
        await this.service.render();

        if (tab === 'password') {
            // 비밀번호 초기화 탭 선택 시 초기화
            this.isVerified = false;
            this.currentPassword = '';
            this.errorMessages.currentPassword = null;
        } else if (tab === 'otp') {
            // OTP 초기화 탭 선택 시 초기화
            this.isOtpVerified = false;
            this.otpPassword = '';
            this.qrCodeImage = null;
            this.errorMessages.otpPassword = null;
        }
    }

    public async loadUserInfo() {
        if (this.isUserLoading) return;
        this.isUserLoading = true;
        this.userLoadError = false;
        this.service.loading.show();
        try {
            const response = await wiz.call("get_user_info", {}, { timeout: 30000 });
            if (response?.code !== 200 || !response.data || typeof response.data !== 'object') {
                throw new Error('USER_INFO_UNAVAILABLE');
            }
            this.user = response.data;
        } catch (_) {
            this.user = null;
            this.userLoadError = true;
        } finally {
            this.isUserLoading = false;
            this.service.loading.hide();
            await this.service.render();
        }
    }

    public async saveUserInfo() {
        if (this.isProfileSubmitting) return;
        this.isProfileSubmitting = true;
        this.service.loading.show();
        const profile = {
            first_name: this.user.first_name,
            last_name: this.user.last_name,
            institution: this.user.institution,
            department: this.user.department
        };
        let response: any;
        try {
            response = await wiz.call("update_user_info", profile);
        } catch {
            response = { code: 503, data: "저장 결과를 확인하지 못했습니다. 같은 내용으로 다시 저장해주세요." };
        } finally {
            this.isProfileSubmitting = false;
            this.service.loading.hide();
        }
        if (response.code === 200) {
            Object.assign(this.user, response.data.profile);
            await this.service.alert.success("기본 정보가 성공적으로 업데이트되었습니다.");
        } else {
            const message = typeof response.data === 'string' ? response.data : response.data?.message;
            await this.service.alert.error(message || "기본 정보 업데이트에 실패했습니다.");
        }
    }

    private async emailRequest(method: string, data: any = {}) {
        try {
            const result: any = await wiz.call(method, data, { timeout: 135000 });
            // jQuery returns an XHR object for HTTP failures, not the JSON body.
            const response = result?.responseJSON || result;
            const code = response?.code ?? result?.status ?? 503;
            let payload = response?.data;
            if (!this.emailChangeError(payload, '')) {
                const message = code === 401 ? "로그인이 만료되었습니다. 다시 로그인해주세요."
                    : code === 403 ? "이메일 변경 권한을 확인하지 못했습니다. 다시 로그인해주세요."
                    : code === 404 ? "이메일 변경 기능에 연결하지 못했습니다. 관리자에게 문의해주세요."
                    : "이메일 변경 요청에 실패했습니다. 잠시 후 다시 시도해주세요.";
                if (code !== 200) payload = {message};
            }
            return {code, data: payload};
        } catch (_) {
            return { code: 503, data: { message: "처리 결과를 확인하지 못했습니다. 다시 시도해주세요." } };
        }
    }

    private async restoreEmailChange() {
        const response = await this.emailRequest('get_email_change_state');
        if (response.code !== 200) {
            this.setEmailChangeMessage(this.emailChangeError(response.data, "이메일 변경 상태를 확인하지 못했습니다."));
            return;
        }
        const state = response.data;
        if (state.current_email) this.user.email = state.current_email;
        this.emailChangePending = state.phase === 'verified';
        this.emailChangeLocked = !!state.locked;
        this.emailChangeStep = state.phase === 'identity' ? 'identity' : 'verify';
        if (state.email) this.emailChange.email = state.email;
        if (this.emailChangePending) {
            this.setEmailChangeMessage("인증이 완료되었습니다. 다시 적용하기를 눌러 변경을 완료해주세요.", 'success');
        } else if (state.needs_reauth) {
            this.setEmailChangeMessage("본인 확인 시간이 만료되었습니다. 다시 인증해주세요.");
        }
    }

    public async openEmailChange() {
        if (this.isEmailChangeSubmitting) return;
        this.resetEmailChangeState();
        this.isEmailChangeOpen = true;
        this.isEmailChangeSubmitting = true;
        try {
            await this.restoreEmailChange();
        } finally {
            this.isEmailChangeSubmitting = false;
            await this.service.render();
        }
    }

    public async closeEmailChangeModal() {
        if (this.isEmailChangeSubmitting) return;
        // Closing only hides the dialog; verified jobs survive reloads/reopens.
        this.isEmailChangeOpen = false;
        this.emailChange.password = this.emailChange.otp = '';
        this.emailChange.onetimepass = '';
        await this.service.render();
    }

    private resetEmailChangeState() {
        this.emailChangeStep = 'identity';
        this.emailChangeMessage = '';
        this.emailChangeMessageType = 'error';
        this.emailChangePending = false;
        this.emailChangeLocked = false;
        this.emailChange = { email: '', password: '', otp: '', onetimepass: '' };
    }

    private setEmailChangeMessage(message: string, type: 'success' | 'error' = 'error') {
        this.emailChangeMessage = message;
        this.emailChangeMessageType = type;
    }

    private emailChangeError(data: any, fallback: string) {
        return typeof data === 'string' ? data : data?.message || fallback;
    }

    private async submitEmailChange(action: string) {
        if (this.isEmailChangeSubmitting) return;
        this.isEmailChangeSubmitting = true;
        this.emailChangeMessage = '';
        this.service.loading.show();
        let completed = false;
        try {
            const payload = action === 'send_email_change_code'
                ? {email: this.emailChange.email, password: this.emailChange.password + this.emailChange.otp.trim()}
                : action === 'confirm_email_change' ? {onetimepass: this.emailChange.onetimepass} : {};
            const response = await this.emailRequest(action, payload);
            this.emailChange.password = this.emailChange.otp = '';
            if (response.code === 200) {
                if (action === 'confirm_email_change') {
                    this.user.email = response.data.email;
                    this.isEmailChangeOpen = false;
                    this.resetEmailChangeState();
                    completed = true;
                } else if (action === 'cancel_email_change') {
                    this.resetEmailChangeState();
                } else {
                    this.emailChange.onetimepass = '';
                    this.emailChangeStep = 'verify';
                    this.emailChangePending = false;
                    this.setEmailChangeMessage(response.data.message, 'success');
                }
            } else {
                // Even a lost response may follow a completed ownership check.
                // Ask the server which step can safely be retried.
                await this.restoreEmailChange();
                this.setEmailChangeMessage(this.emailChangeError(response.data, "이메일 변경에 실패했습니다."));
            }
        } finally {
            this.service.loading.hide();
            this.isEmailChangeSubmitting = false;
            await this.service.render();
        }
        if (completed) await this.service.alert.success("이메일이 변경되었습니다.");
    }

    public async sendEmailChangeCode() {
        if (this.isEmailChangeSubmitting) return;
        if (!this.emailChange.email || !this.emailChange.password) {
            this.setEmailChangeMessage("새 이메일과 현재 비밀번호 및 OTP를 입력해주세요.");
            return await this.service.render();
        }
        const error = this.credentialError(this.emailChange.password, this.emailChange.otp);
        if (error) {
            this.setEmailChangeMessage(error);
            return await this.service.render();
        }
        await this.submitEmailChange('send_email_change_code');
    }

    public async resendEmailChangeCode() {
        if (this.emailChangePending) return;
        await this.submitEmailChange('resend_email_change_code');
    }

    public async restartEmailChange() {
        if (this.emailChangeLocked) return;
        await this.submitEmailChange('cancel_email_change');
    }

    public async confirmEmailChange() {
        if (this.isEmailChangeSubmitting) return;
        if (!this.emailChangePending && !this.emailChange.onetimepass) {
            this.setEmailChangeMessage("인증번호를 입력해주세요.");
            return await this.service.render();
        }
        await this.submitEmailChange('confirm_email_change');
    }

    public getLabel(key: string) {
        return this.tabs.find(t => t.key === key)?.label ?? '';
    }
}

export default PageMypageComponent;